import request from "@/util/http";

export function listLiveRoom(params) {
  return request({ url: '/marketing/biz/live_room/list', method: 'get', params })
}

export function getLiveRoom(id) {
  return request({ url: '/marketing/biz/live_room/view', method: 'get', params: { id } })
}
